import React, { useState } from "react";
import "./SenderWhitelist.css";
import Swal from "sweetalert2";
import { Messante_URL } from './apiConfig';
import { Link } from "react-router-dom";

const SenderWhitelist = ({ onNavigate }) => {
    const [showprogress, setshowprogress] = useState(false);
    const [senderType, setSenderType] = useState("promotional");
    const [bulkFileType, setBulkFileType] = useState("csv");
    const [userId, setUserId] = useState("");
    const [entityId, setEntityId] = useState("");
    const [senderId, setSenderId] = useState("");
    const [bulkUserId, setBulkUserId] = useState("");
    const [bulkEntityId, setBulkEntityId] = useState("");
    const [operatorId, setOperatorId] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;

    const handleFileChange = (event) => {

        const file =
            event.target.files?.[0];

        if (file) {
            setSelectedFile(file);
        }
    };

    const handleSingleSubmit = async (event) => {
        event.preventDefault();
        if (!entityId || !senderId) {
            setshowprogress(false);
            const re = await Swal.fire({
                title: "Value Error!",
                text: "Please fill all Required fields. Some field(s) are missing.",
                icon: "error",
                allowOutsideClick: false
            });
        }

        else {
            try {
                setshowprogress(true)
                const apiUrl = `${Messante_URL}/sender`;
                const requestBody = {
                    userID: sessionusername,
                    sender: senderId,
                    peid: entityId,
                    senderType: senderType === "promotional" ? "PROMOTIONAL" : "TRANSACTIONAL",
                    activityByUserId: sessionusername,
                    parentuid: sessionusername
                }

                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                };

                // API Request
                const response = await fetch(apiUrl, fetchOptions);
                const data = await response.json();

                if (data.status === "Success" || data.errorCode === "000") {
                    setshowprogress(false);
                    const re = await Swal.fire({
                        title: "Success",
                        text: data.errorDesc,
                        icon: "success"
                    });

                    if (re.isConfirmed) {
                        setSenderId("");
                        setEntityId("");
                        setSenderType("promotional")
                    }
                }

                else {
                    setshowprogress(false);
                    await Swal.fire({
                        title: `Sender Whitelisting Error`,
                        text: data.errorDesc || "Something went wrong",
                        icon: "error"
                    });
                }
            }

            catch (error) {
                console.error("API Request Error:", error.message);
                setshowprogress(false);

                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: error.message,
                    icon: 'error'
                });
            }
        }
    };

    const handleBulkSubmit = async (event) => {
        event.preventDefault();
        if (!bulkEntityId || !selectedFile) {
            setshowprogress(false);
            const re = await Swal.fire({
                title: "Value Error!",
                text: "Please fill all Required fields. Some field(s) are missing.",
                icon: "error",
                allowOutsideClick: false
            });
        }

        else {
            try {
                setshowprogress(true)
                const apiUrl = `${Messante_URL}/bulksender`;
                const formData = new FormData();

                // Append vuser as a JSON string
                formData.append("sender", "All");
                formData.append("senderType", "0");
                formData.append("userID", sessionusername);
                formData.append("operatorid", "SmartPing");
                formData.append("peid", bulkEntityId);
                formData.append("activityByUserId", sessionusername);
                formData.append("file", selectedFile);
                formData.append("parentuid", sessionusername);
                // formData.forEach((value, key) => {
                //     console.log(key + ":", value);
                // });

                const uploadResponse = await fetch(apiUrl, {
                    method: "POST",
                    body: formData,
                });

                const result = await uploadResponse.json();
                console.log("result:", result);
                if (result.status === "Success" || result.errorCode === "000") {
                    setshowprogress(false);
                    const re = await Swal.fire({
                        title: "Success",
                        html: result.errorDesc.replace(/;/g, "<br>"),
                        icon: "success"
                    });

                    if (re.isConfirmed) {
                        setBulkEntityId("");
                        setSelectedFile(null);
                    }
                }

                else {
                    setshowprogress(false);
                    const formatted = (result.errorDesc || "Something went wrong").replace(/;/g, "<br>");
                    const re = await Swal.fire({
                        title: `Bulk Template Whitelist Error`,
                        html: formatted,
                        icon: "error"
                    });

                    if (re.isConfirmed) {
                        setBulkEntityId("");
                        setSelectedFile(null);
                    }
                }
            }

            catch (error) {
                console.error("API Request Error:", error.message);
                setshowprogress(false);

                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: error.message,
                    icon: 'error'
                });
            }
        }
    };

    const handleCancelSingle = () => {

        setUserId("");
        setEntityId("");
        setSenderId("");
        setSenderType("promotional");
    };

    const handleCancelBulk = () => {

        setBulkUserId("");
        setBulkEntityId("");
        setOperatorId("");
        setSelectedFile(null);
    };


    return (

        <div className="sender-whitelist-page">


            {/* ==================================================
                PAGE HEADER
            ================================================== */}

            <div className="sender-whitelist-page-header">

                <div className="sender-page-title-section">

                    <div className="sender-page-icon">
                        <i className="fa fa-shield-alt" style={{ fontSize: "0.7rem" }} />
                    </div>

                    <div>

                        <h2>
                            Sender Whitelist
                        </h2>

                        <p>
                            Manage and whitelist sender IDs
                        </p>

                    </div>

                </div>

                <Link
                    type="button"
                    className="view-whitelist-btn"
                   to="/viewsenderwhitelisted"
                >

                    <i className="fa fa-list-ul" />

                    <span>
                        View Whitelisted Senders
                    </span>

                    <i className="fa fa-arrow-right" />

                </Link>

            </div>

            <div className="sender-whitelist-grid">
                <div className="sender-whitelist-card" style={{ position: "relative" }}>
                    {showprogress && (
                        <div className="spinner-overlay">
                            <div className="custom-spinner"></div>
                        </div>
                    )}
                    <div className={showprogress ? "blurred" : ""} style={{ width: "100%", height: "100%" }}>
                        <div className="sender-card-header">
                            <div className="sender-card-header-icon">
                                <i className="fa fa-user-plus" />
                            </div>

                            <div>
                                <h3>Whitelist Sender</h3>
                                <p>One By One</p>
                            </div>
                        </div>

                        <form className="sender-card-body" onSubmit={handleSingleSubmit}>
                            <div className="sender-form-group">

                                <label>
                                    Sender ID Type
                                </label>

                                <div className="sender-radio-group">

                                    <label className="sender-radio-option">

                                        <input
                                            type="radio"
                                            name="senderType"
                                            value="promotional"
                                            checked={
                                                senderType ===
                                                "promotional"
                                            }
                                            onChange={() =>
                                                setSenderType(
                                                    "promotional"
                                                )
                                            }
                                        />

                                        <span className="custom-radio">
                                            <span />
                                        </span>

                                        <span>
                                            Promotional
                                        </span>

                                    </label>


                                    <label className="sender-radio-option">

                                        <input
                                            type="radio"
                                            name="senderType"
                                            value="others"
                                            checked={
                                                senderType ===
                                                "others"
                                            }
                                            onChange={() =>
                                                setSenderType(
                                                    "others"
                                                )
                                            }
                                        />

                                        <span className="custom-radio">
                                            <span />
                                        </span>

                                        <span>
                                            Others
                                            <small>
                                                (Transactional /
                                                Implicit /
                                                Explicit)
                                            </small>
                                        </span>

                                    </label>

                                </div>

                            </div>

                            <div className="sender-form-group">

                                <label>
                                    Entity ID
                                </label>

                                <input
                                    type="text"
                                    value={entityId}
                                    onChange={(e) =>
                                        setEntityId(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Enter Entity ID"
                                />

                            </div>

                            <div className="sender-form-group">
                                <label>
                                    Sender ID
                                </label>

                                <input
                                    type="text"
                                    value={senderId}
                                    onChange={(e) =>
                                        setSenderId(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Enter Sender ID"
                                />

                            </div>

                            <div className="sender-form-actions">

                                <button
                                    type="submit"
                                    className="sender-submit-btn"
                                >
                                    <i className="fa fa-check" />
                                    Submit
                                </button>

                                <button
                                    type="button"
                                    className="sender-cancel-btn"
                                    onClick={
                                        handleCancelSingle
                                    }
                                >
                                    Cancel
                                </button>

                            </div>
                        </form>
                    </div>
                </div>

                <div className="sender-whitelist-card" style={{ position: "relative" }}>
                    {showprogress && (
                        <div className="spinner-overlay">
                            <div className="custom-spinner"></div>
                        </div>
                    )}
                    <div className={showprogress ? "blurred" : ""} style={{ width: "100%", height: "100%" }}>
                        <div className="sender-card-header">

                            <div className="sender-card-header-icon bulk">
                                <i className="fa fa-cloud-upload-alt" />
                            </div>

                            <div>

                                <h3>
                                    Whitelist Sender
                                </h3>

                                <p>
                                    Bulk Upload
                                </p>

                            </div>

                        </div>

                        <form
                            className="sender-card-body"
                            onSubmit={
                                handleBulkSubmit
                            }
                        >


                            {/* FILE TYPE */}

                            <div className="sender-form-group">

                                <label>
                                    File Type
                                </label>

                                <div className="sender-radio-group">

                                    <label className="sender-radio-option">

                                        <input
                                            type="radio"
                                            name="bulkFileType"
                                            value="csv"
                                            checked={
                                                bulkFileType ===
                                                "csv"
                                            }
                                            onChange={() =>
                                                setBulkFileType(
                                                    "csv"
                                                )
                                            }
                                        />

                                        <span className="custom-radio">
                                            <span />
                                        </span>

                                        <span>
                                            CSV
                                        </span>

                                    </label>


                                    <label className="sender-radio-option">

                                        <input
                                            type="radio"
                                            name="bulkFileType"
                                            value="xlsx"
                                            checked={
                                                bulkFileType ===
                                                "xlsx"
                                            }
                                            onChange={() =>
                                                setBulkFileType(
                                                    "xlsx"
                                                )
                                            }
                                        />

                                        <span className="custom-radio">
                                            <span />
                                        </span>

                                        <span>
                                            XLSX
                                        </span>

                                    </label>

                                </div>

                            </div>


                            {/* USER */}

                            {/* <div className="sender-form-group">

                            <label>
                                User ID
                            </label>

                            <select
                                value={bulkUserId}
                                onChange={(e) =>
                                    setBulkUserId(
                                        e.target.value
                                    )
                                }
                            >

                                <option value="">
                                    Select User ID
                                </option>

                                <option value="user001">
                                    user001
                                </option>

                                <option value="user002">
                                    user002
                                </option>

                                <option value="user003">
                                    user003
                                </option>

                            </select>

                        </div> */}


                            {/* ENTITY + OPERATOR */}

                            {/* <div className="sender-two-column"> */}

                            <div className="sender-form-group">

                                <label>
                                    Entity ID
                                </label>

                                <input
                                    type="text"
                                    value={bulkEntityId}
                                    onChange={(e) =>
                                        setBulkEntityId(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Enter Entity ID"
                                />

                            </div>


                            {/* <div className="sender-form-group">

                                <label>
                                    Operator Name
                                </label>

                                <select
                                    value={operatorId}
                                    onChange={(e) =>
                                        setOperatorId(
                                            e.target.value
                                        )
                                    }
                                >

                                    <option value="">
                                        Select Operator ID
                                    </option>

                                    <option value="operator1">
                                        Operator 1
                                    </option>

                                    <option value="operator2">
                                        Operator 2
                                    </option>

                                </select>

                            </div> */}

                            {/* </div> */}


                            {/* UPLOAD */}

                            <div className="sender-form-group">

                                <label>
                                    Upload File
                                </label>

                                <label className="sender-upload-box">

                                    <input
                                        type="file"
                                        accept={
                                            bulkFileType ===
                                                "csv"
                                                ? ".csv"
                                                : ".xlsx,.xls"
                                        }
                                        onChange={
                                            handleFileChange
                                        }
                                    />

                                    <div className="sender-upload-icon">
                                        <i className="fa fa-cloud-upload-alt" />
                                    </div>

                                    <div className="sender-upload-title">
                                        {selectedFile
                                            ? selectedFile.name
                                            : "Click to upload file"}
                                    </div>

                                    <div className="sender-upload-hint">
                                        {bulkFileType === "csv"
                                            ? "CSV file supported"
                                            : "XLSX / XLS file supported"}
                                    </div>

                                </label>

                            </div>


                            {/* BUTTONS */}

                            <div className="sender-form-actions">

                                <button
                                    type="submit"
                                    className="sender-submit-btn"
                                >
                                    <i className="fa fa-upload" />
                                    Submit
                                </button>

                                <button
                                    type="button"
                                    className="sender-cancel-btn"
                                    onClick={
                                        handleCancelBulk
                                    }
                                >
                                    Cancel
                                </button>

                            </div>

                        </form>
                    </div>
                </div>

            </div>

        </div>
    );
};

export default SenderWhitelist;